module.exports = __webpack_public_path__ + "img/guizhangzhidu.4a48af71.png";